import React, { useEffect, useRef } from "react";
import Slider from 'react-slick';
import { Button } from '../../Atoms';
import { useNavigate, Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import { FaBuilding, FaCarSide, FaChargingStation } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import MonitorImage from '../../Assets/become_distributor/cms-c.webp'
import userauthentication from '../../Assets/home/user.png'
import remotemanagement from '../../Assets/home/OCPP.png'
import hardwarediagnostic from '../../Assets/home/Feature rich.png'
import fleetmanagement from '../../Assets/home/fleet management.png'
import dynamicloadmanagement from '../../Assets/home/dynamic load management.png'
import customaccesscontrol from '../../Assets/home/Customizable.png'
import carbonwallet from '../../Assets/home/carbon wallet.png'
import security from '../../Assets/home/secure by.png'
import upi from '../../Assets/home/payment integration.png'
import { ButtonNav } from '../../Atoms/ButtonNav';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import cmsandapp from '../../Assets/brochures/CMS_Brochure_VM.pdf';

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

const chargers = [
    "Ksipra AC Charger",
    "Ksipra Bharat AC",
    "Ksipra Compact AC",
    "Ksipra AC Hybrid",
    "AC 15D Charger",
    "AC 22D Charger",
];


const logos = [
    { name: "OCPP and OCPI configuration for easy integration", img: remotemanagement },
    { name: "Feature rich firmware management ", img: hardwarediagnostic },
    { name: "Customizable configuration option available", img: customaccesscontrol },
    { name: "User and Fare management  ", img: userauthentication },
    // { name: "Dynamic load management", img: dynamicloadmanagement },
    // { name: "Supports partner/Fleet management", img: fleetmanagement },
    { name: "Secure by the Made-in-India technology ", img: security },
    // { name: "Carbon wallet integration", img: carbonwallet },
    { name: "Payment integration with multiple payment partners", img: upi },
];




const CMS = () => {

    const sectionsRef = useRef([]);
    const titlesRef = useRef([]);

    useEffect(() => {
        sectionsRef.current.forEach((section, i) => {
            ScrollTrigger.create({
                trigger: section,
                start: "top center",
                end: "bottom center",
                onEnter: () => highlightTitle(i),
                onEnterBack: () => highlightTitle(i),
            });
        });

        const highlightTitle = (index) => {
            titlesRef.current.forEach((el, i) => {
                if (i === index) {
                    el.classList.add("active");
                } else {
                    el.classList.remove("active");
                }
            });
        };
    }, []);

    const navigate = useNavigate();
    return (
        <section className=" containers-min mx-auto">
            <div >
                <div
                    className="min-h-[50vh] blade-margin-sm"
                >
                    <div className="bg-grey rounded-2xl p-6 md:p-8 space-y-6 md:space-y-8">
                        <div className='flex flex-col md:flex-row'>
                            <div className="flex items-center w-full md:w-2/4 group relative">
                                <img src={MonitorImage} alt="CMS" />
                            </div>

                            <div className="w-full md:w-2/4">
                                <div className=" flex flex-col gap-2 flex-nowrap">
                                    <h4 className="card-title font-bold font-gilroy">
                                        Charging Management System (CMS)
                                    </h4>
                                    <span className=" text-opacity-70 text-sm  sm:text-base  md:text-lg  max-w-lg xl:max-w-xl  pr-5 font-poppins">
                                        An end-to-end EV Charging Management Solution to effortlessly track, manage, optimize, & scale your EV Charging Business
                                    </span>
                                    <div className="py-3 flex flex-col divide-y divider-grey">
                                        <div className="flex flex-col flex-nowrap gap-4 py-2  sm:py-4 lg:py-6">
                                            <span className="font-semibold  text-lg xl:text-xl font-gilroy">
                                                Features
                                            </span>
                                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mt-6">
                                                {logos.map((car, index) => (
                                                    <div key={index} className="flex flex-col items-start">
                                                        <img
                                                            src={car.img}
                                                            alt={car.name}
                                                            className="w-12 h-12 sm:w-10 sm:h-10 transition-transform"
                                                        />
                                                        <p className="font-semibold text-sm sm:text-base text-gray-600 mt-2 font-poppins">{car.name}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="flex items-center py-2 sm:py-3 gap-3">
                                            <div onClick={() => navigate('/get-in-touch')}>
                                                <button
                                                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                                >
                                                    <span className="flex justify-center items-center">
                                                        <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                                        <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                                    </span>
                                                    Contact Us
                                                </button>
                                            </div>

                                            <div className='group cursor-pointer'>
                                                <a href="https://resources.verdemobility.com/files/CMS.pdf" target="_blank" className='text-gray-600'>
                                                    <button
                                                        className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                                    >
                                                        <span className="flex justify-center items-center">
                                                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                                            <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                                        </span>
                                                        Brochure
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>

    );
};

export default CMS;
